import { makeAutoObservable } from 'mobx';
import CmsHotelData from '../Models/CMS/CmsHotelData';

export class DealFinderStore {
  selectedHotels: CmsHotelData[] = [];

  dealSort = true;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedHotels(selectedHotels: CmsHotelData[]) {
    this.selectedHotels = selectedHotels;
  }

  setDealSort(dealSort: boolean) {
    this.dealSort = dealSort;
  }
}
